module.exports = __webpack_public_path__ + "img/adi.069c10c9.png";